import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from '@emotion/styled';
import { useCallback, useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { FaCloudUploadAlt } from 'react-icons/fa';
const DropzoneRoot = styled.div `
  position: relative;
  height: 100%;
  width: 100%;
`;
const DropzoneDragActive = styled.div `
  font-size: 1.5em;
  font-weight: 600;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  opacity: 0.7;
  background-color: white;
  border: 5px dashed;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  border-color: ${({ borderColor }) => borderColor};
  color: ${({ color }) => color};
`;
const DropzoneEmpty = styled.div `
  font-size: 1.5em;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 1em;
  border: 5px dashed;
  cursor: pointer;

  border-color: ${({ borderColor }) => borderColor};
  color: ${({ color }) => color};
`;
export function DropZone(props) {
    return _jsx(DropZoneContent, { ...props });
}
export function DropZoneContainer(props) {
    return _jsx(DropZoneContent, { ...props });
}
function DropZoneContent(props) {
    const { color = 'black', borderColor = 'gray', children = null, onDrop, emptyText = 'Click or drag and drop to add data.', onClick, fileValidator, } = props;
    const hasChildren = children !== null;
    const handleOnDrop = useCallback((acceptedFiles, rejectedFiles) => {
        onDrop?.(acceptedFiles, rejectedFiles);
    }, [onDrop]);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        noClick: hasChildren,
        validator: fileValidator,
        onDrop: handleOnDrop,
    });
    const getPropsOptions = useMemo(() => {
        if (onClick) {
            return { onClick };
        }
    }, [onClick]);
    return (_jsxs(DropzoneRoot, { ...getRootProps(getPropsOptions), children: [children, isDragActive ? (_jsxs(DropzoneDragActive, { borderColor: borderColor, color: color, children: [_jsx(FaCloudUploadAlt, { size: 70 }), _jsx("p", { children: "Drop the files here." })] })) : !hasChildren ? (_jsx(DropzoneEmpty, { borderColor: borderColor, color: color, children: emptyText })) : null, _jsx("input", { ...getInputProps() })] }));
}
//# sourceMappingURL=DropZone.js.map